import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/app/[locale]/error.tsx");
